import * as yup from 'yup';

const schema = yup.object().shape({
  name: yup
    .string()
    .required()
    .trim(),
  audio: yup
    .mixed()
    .test('fileFormat', 'wav format only', value => {
      return value && value[0] && ['audio/wav'].includes(value[0].type);
    })
    .test('required', 'field is required', value => {
      return value && value[0];
    }),
  department: yup
    .string()
    .required()
    .trim(),
  description: yup
    .string()
    .required()
    .trim(),
  waitsec: yup
    .number()
    .required()
    .positive()
    .integer()
    .min(0)
    .max(10)
});

export default schema;
